module.exports = __webpack_public_path__ + "static/media/blueroom.396d301b.png";